import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import TrayContainer from "../../atoms/TrayContainer";

const StyledOffCanvasTrayHolder = styled(TrayContainer)`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  ${breakpoints.smUp} {
    width: 500px;
  }
  ${breakpoints.mdUp} {
    width: ${(props) => props.large && "700px"};
  }
  ${breakpoints.smDown} {
    padding-bottom: calc(100px + env(safe-area-inset-bottom));
    left: 0;
    ${(props) =>
      props.isInBoxAndCartTray &&
      css`
        top: 0;
      `}
  }
`;

const OffCanvasTrayHolder = ({
  isOffcanvasOpened = false,
  children,
  large = false,
  isInBoxAndCartTray = false,
}) => (
  <StyledOffCanvasTrayHolder
    isOpened={isOffcanvasOpened}
    isOffcanvasOpened={isOffcanvasOpened}
    large={large}
    isInBoxAndCartTray={isInBoxAndCartTray}
  >
    {children}
  </StyledOffCanvasTrayHolder>
);

OffCanvasTrayHolder.propTypes = {
  children: PropTypes.node.isRequired,
  isOffcanvasOpened: PropTypes.bool,
  large: PropTypes.bool,
  isInBoxAndCartTray: PropTypes.bool,
};

export default OffCanvasTrayHolder;
